// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uMTb","placeholdersHeader":"styles_placeholdersHeader__19SSa","editorStyle":"styles_editorStyle__1QrrB","placeholdersBox":"styles_placeholdersBox__DJrvW"};